<!--
=========================================================================================
    Message Card Control
==========================================================================================
-->

<template functional>
  <div id="communication-message-card">
    <component v-if="props.type" :is="injections.components[props.type]" :data="props.data" :parentEl="'#communication-message-card'" />
    <div v-else>Nothing</div>              
  </div>                                          
</template>                                       
                                                  
<script>                                          
export default {                                  
  inject: {                                       
    components: {                                 
      default: {                                  
        pm: () => import(`./PM/TopicPage.vue`),   
        chat: () => import(`./Chat/TopicPage.vue`),
        webboard: () => import(`./Webboard/TopicCard.vue`),
      }                                           
    },                                            
  },                                              
  props: {                                        
    data: {                                       
      type: Object,                               
      // required: true,                          
      default: null                               
    },                                            
    type: {                                       
      type: String,                               
      required: true,                             
      default: null                               
    }                                             
  },                                              
  methods: {                                      
    importSubcomponent: (type) => import(`./${type.toLowerCase()}/MessageCard.vue`)
  }                                               
}                                                 
</script>                                         
                                                  